import {computed,toValue,inject,provide,type InjectionKey,type MaybeRefOrGetter} from 'vue'
import {useI18n} from 'vue-i18n'
import {staffNounTerms,staffRoleNoun,capitalizeNoun,type StaffNounEvent,type StaffRole} from '@/utils/staffNouns'
import {participantNounTerms,type ParticipantNounEvent} from '@/utils/participantNouns'
type EventNouns=StaffNounEvent & ParticipantNounEvent
const eventNounContext:InjectionKey<MaybeRefOrGetter<EventNouns|undefined>>=Symbol('event-noun-context')
/** Inject event-local display nouns into named translations; role IDs/permissions remain unchanged. */
export function useEventTerminology(event?:MaybeRefOrGetter<EventNouns|undefined>){
 const inherited=inject(eventNounContext,()=>undefined)
 const resolved=computed(()=>({...toValue(inherited),...toValue(event)}))
 provide(eventNounContext,resolved)
 const i18n=useI18n()
 const terms=computed(()=>({...staffNounTerms(resolved.value,i18n.t('tryoutSetup.staff.roles.selector')),...participantNounTerms(resolved.value,i18n.t('sessionCapture.defaults.participant'))}))
 const translate=i18n.t as unknown as (...args:unknown[])=>string
 const t=((key:string,...args:unknown[])=>{
  if(args[0] && typeof args[0]==='object' && !Array.isArray(args[0]))return translate(key,{...terms.value,...args[0]},...args.slice(1))
  if(typeof args[0]==='number')return translate(key,terms.value,...args)
  if(!args.length)return translate(key,terms.value)
  return translate(key,...args)
 }) as typeof i18n.t
 function roleLabel(role:StaffRole,plural=false){return capitalizeNoun(staffRoleNoun(resolved.value,role,i18n.t(`tryoutSetup.staff.roles.${role}`),plural))}
 return {...i18n,t,terms,roleLabel}
}
